export const FIELD_DATA_CONFIG = {
  gridConfig: [
    { label: '编码',
      prop: 'fieldCode' },
    { label: '名称',
      prop: 'fieldName',
      render: (h, params) => {
        return h('input', {
          class:'el-input__inner',
          domProps: {
            value: params.row.name
          },
          on: {
            input: function(event) {
              params.row.name = event.target.value
            }
          }
        })
      }
    },{ label: '是否查询',
      prop: 'canQuery',
      render: (h, params) => {
        return h('input', {
          class:'el-input__inner',
          domProps: {
            value: params.row.name
          },
          on: {
            input: function(event) {
              params.row.name = event.target.value
            }
          }
        })
      }
    }
  ],
  dialogConfig: {
    width: '50%',
    labelWidth: '120px'
  },
  queryConfig: [
  ],
  // crud的模态框表单配置，可配置表单类型，验证规则，是否必填,col-span布局可通过span参数配置
  formConfig: [
    { span: 24, 
      label: '代码',
      prop: 'code',
      type: 'text',
      rules:
      { required: true,
        message: '请输入表编码',
        trigger: 'blur'
      },
      data: []
    },
    { span: 24,
      label:'名称',
      prop: 'name',	      
      type: 'text',
      rules:
      { required: true,
        message: '请输入表名称',
        trigger: 'blur'
      },
      data: []
    }
  ],
  // crud的操作按钮配置，基础按钮有添加、修改、删除、查看，还可以配置扩展按钮
  gridBtnConfig: {
    create: true, update: false, delete: true, view: false,
    expands:[{
      emitName:'stragetyonfig',
      name: '配置'
    }]
  },
  // 表单基础数据类型，需要预先赋值
  formModel: {
    'id': '',
    'code': '',
    'name': '',
    'tableId': ''
  },
  queryModel: {
    'tableId': ''
  }
}




// WEBPACK FOOTER //
// ./src/components/generator/createCode/config/fields.js